import { Card, Stack, Switch, Tooltip, Typography } from "@mui/material";

import { STATIONS } from "Constants/Stations";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { toggleVisibility as toggleStations } from "Redux/stationsSlice";
import { toggleVisibility } from "Redux/filtersSlice";

import MenuButton from "./Button";

export default function Stations() {
  const dispatch = useAppDispatch();

  const { visibility } = useAppSelector((state) => state.filters);
  const { visible } = useAppSelector((state) => state.stations);
  const { page } = useAppSelector((state) => state.page);
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleClick = (key: string) => {
    dispatch(toggleVisibility(key));
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        {STATIONS.map((station) => (
          <MenuButton isActive={visibility.includes(station.type)} onClick={() => handleClick(station.type)} title={station.text}>
            {station.icon}
          </MenuButton>
        ))}
        <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={() => dispatch(toggleStations())} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
